import { AppOffer } from 'state/loyalty/types';

type OfferGroupEvaluationContext = {
  offerGroup: { canOnlyChooseOne?: boolean };
  hasOfferInCart: boolean;
  visibleOffersInGroup: AppOffer[];
};
type ReasonToHide = string;
type VisibilityCheck = (context: OfferGroupEvaluationContext) => ReasonToHide | void;
type EvaluationResult = { visible: true } | { visible: false; reason: ReasonToHide };

export function evaluateOfferGroupVisibility(
  context: OfferGroupEvaluationContext
): EvaluationResult {
  const evaluations: VisibilityCheck[] = [
    hideIfNoVisibleOffers,
    hideIfAllOffersHaveInlineAlerts,
    hideIfCanOnlyChooseOneAndHasOfferInCart,
  ];

  for (const evaluate of evaluations) {
    const result = evaluate(context);
    if (typeof result === 'string') {
      return { visible: false, reason: result };
    }
  }

  return { visible: true };
}

export const hideIfNoVisibleOffers: VisibilityCheck = ({ visibleOffersInGroup }) => {
  if (visibleOffersInGroup.length === 0) {
    return 'No visible offers in group';
  }
};

export const hideIfAllOffersHaveInlineAlerts: VisibilityCheck = ({ visibleOffersInGroup }) => {
  const offersWithInlineAlerts = visibleOffersInGroup.filter(offer => !!offer?.inlineAlertMessage)
    .length;

  const allOffersHaveInlineAlerts =
    offersWithInlineAlerts && offersWithInlineAlerts >= visibleOffersInGroup.length;
  if (allOffersHaveInlineAlerts) {
    return 'All offers have inline alerts';
  }
};

export const hideIfCanOnlyChooseOneAndHasOfferInCart: VisibilityCheck = ({
  offerGroup,
  hasOfferInCart,
}) => {
  if (offerGroup.canOnlyChooseOne && hasOfferInCart) {
    return 'Can only choose one and has offer in cart';
  }
};
